import "./ArchiveTable.scss";
import { useContext, useState } from "react";
import moment from "moment-jalaali";
import { getFlagUrl } from "../../utils/getFlagUrl";

const ArchiveTable = ({ rates, offset }) => {
  return (
    <>
      <div className="archive-table-container">
        <table className="archive-table rounded-2xl">
          <thead className="rounded-2xl">
            <tr className="bg-archive">
              <th className="rounded-ss-2xl">ردیف</th>
              <th>عنوان </th>
              <th>خرید</th>
              <th>فروش</th>
              <th>ساعت</th>
              <th className="rounded-se-2xl">تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {rates?.rows && rates?.rows.length !== 0 ? (
              rates?.rows.map((item, i) => {
                const buyPriceStatus =
                  Number(item.buyPrice) > Number(item.pBuyPrice);
                const sellPriceStatus =
                  Number(item.sellPrice) > Number(item.pSellPrice);

                // Convert updatedAt to Jalali time and date
                const jalaliTime = moment(item.updatedAt).format("HH:mm:ss");
                const jalaliDate = moment(item.updatedAt).format("jYYYY/jMM/jDD");

                return (
                  <tr key={i}>
                    <td>{i + 1 + offset}</td>
                    <td className="row-title">
                      <span
                        style={{
                          height: "max-content",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {" "}
                        <img
                          style={{ paddingInline: "5px" }}
                          className={`flag`}
                          src={
                            item["currency.symbol"]
                              ? getFlagUrl(item["currency.symbol"])
                              : item["coin.name"] === "سکه تمام بهار آزادی"
                              ? require(`../../assets/coins/tamam.png`)
                              : item["coin.name"] === "سکه امامی 86"
                              ? require(`../../assets/coins/emami.png`)
                              : item["coin.name"] === "سکه امامی (قبل ۸۶)"
                              ? require(`../../assets/coins/emami-B86.png`)
                              : item["coin.name"] === "سکه نیم (قبل ۸۶)"
                              ? require(`../../assets/coins/tamam-B86.png`)
                              : item["coin.name"] === "سکه ربع (قبل ۸۶)"
                              ? require(`../../assets/coins/tamam-B86.png`)
                              : require(`../../assets/coins/tamam.png`)
                          }
                        />{" "}
                      </span>
                      {item["currency.name"] || item["coin.name"]}
                    </td>
                    <td
                      className={`price ${
                        buyPriceStatus ? `green-price` : `red-price`
                      }`}
                    >
                      {item.buyPrice.toLocaleString()} تومان
                    </td>

                    <td
                      className={`price ${
                        sellPriceStatus ? `green-price` : `red-price`
                      }`}
                    >
                      {item.sellPrice.toLocaleString()} تومان
                    </td>
                    <td>{jalaliTime}</td>
                    <td>{jalaliDate}</td>
                  </tr>
                );
              })
            ) : (
              <tr className="rounded-2xl">
                <td
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                ></td>
                <td>موردی یافت نشد</td>
                <td className={``}></td>
                <td className={`price green-price`}></td>
                <td className={``}></td>
                <td className="rounded-se-2xl" ></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ArchiveTable;
